<template>
  <div class="pt-4 dotted-bg">
    <div class="row">
      <div class="col-4 col-lg-3">
        <about-nav />
      </div>
      <div class="col-7 text-left">
        <!-- <h2 class="mb-4">Contact</h2> -->

        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeSDGnHL4n_kFXNO4JLrSqSBKHbMJo_yVn1TzmjFx4ZexMMhA/viewform?embedded=true" width="750" height="815" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>

      </div>
    </div>
  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  } 
}
</script>

<style lang="scss">
.dotted-bg {
  background-image: repeating-linear-gradient(45deg, rgb(255,255,255) 0px, rgb(255,255,255) 10px,transparent 10px, transparent 11px),repeating-linear-gradient(135deg, rgb(255,255,255) 0px, rgb(255,255,255) 10px,transparent 10px, transparent 11px),linear-gradient(90deg, hsl(256,7%,84%),hsl(256,7%,84%));
}
</style>